/*
 * PC/SP共通関数
 */

/**
 * 現在のカート情報をAjax取得し、取得結果をコールバック関数に渡す。
 * @param {function} callback コールバック関数。(第1引数:総量、第2引数:総価格（整形済み）。エラー時は両方空文字を設定する。
 */
function getCartContent(callback) {

  $.ajax({
    // url: '/order/api/cart.do',
    url: 'https://www.nissen.co.jp/order/api/cart.do',
    data: {
      op: 'display'
    },
    type: 'GET',
    dataType: 'json',
    cache: false
  }).done(function (response) {
    if (response.statusCode == 200 && response.data) {
      var data = response.data;
      callback(data.totalAmount, data.totalPrice);
    } else {
      callback('', '');
    }
  }).fail(function (jqXHR, textStatus, errorThrown) {
    callback('', '');
  });
}

/**
 * カタログ商品情報をAjaxで取得し、取得結果をコールバック関数に渡す。
 * @param {string} catalogCode カタログコード
 * @param {string} catalogItemNumber カタログ商品番号
 * @param {Array} catalogSkuInfos カタログSKU情報の配列 ({ sizeCode, colorCode, price })
 *                                ※カタログ定義jsから与えられた情報。（EFSのSKUの概念とは異なる。SKU毎に品番が異なるケースがあるため使用する）
 * @param {function} callback コールバック関数。第1引数:商品コード、第2引数:サムネイルURL
 */
function getCatalogItemInfo(catalogCode, catalogItemNumber, catalogSkuInfos, callback) {
  catalogCode = (catalogCode == '9999') ? '2305' : catalogCode;
  // var url = '/api/v1/item/catalog/' + catalogCode + '/' + catalogItemNumber + '/json?op=list';
  var url = 'https://www.nissen.co.jp/api/v1/item/catalog/' + catalogCode + '/' + catalogItemNumber + '/json?op=list';
  

  // Ajaxでカタログ情報取得
  $.ajax({
    url: url,
    type: 'GET',
    dataType: 'json'
  }).done(function(data) {

    if (data.itemInfoXML.rcd == 200) {
      if (data.itemInfoXML.itemList || data.itemInfoXML.item) {

      // サーバ側のAPIが古い場合はitemListではなくitemになる
      var itemList = data.itemInfoXML.itemList || [ data.itemInfoXML.item ];
      var i, j, k, item, cataSkuInfo, itemSku, thumbnail;

      // 与えられたSKU順でソート
      var sortedItemsList = [];

      for (i = 0; i < catalogSkuInfos.length; i++) {
        cataSkuInfo = catalogSkuInfos[i];

        for (j = 0; j < itemList.length; j++) {
          item = itemList[j];
          if (!item) continue;

          for (k = 0; k < item.skuList.length; k++) {
            itemSku = item.skuList[k].skuInfo;

            if (itemSku.sNm.indexOf(cataSkuInfo.sizeCode + '=') === 0 && itemSku.dCoNm.indexOf(cataSkuInfo.colorCode + '=') === 0) {
              item.price = '<span class="item-price-out-tax">￥' + getComma(itemSku.spwt) + '</span><span class="item-price-in-tax">(税込￥' + getComma(itemSku.sp) + ')</span>';
              sortedItemsList.push(item);
              itemList[j] = null;
              break;
            }
          }
        }
      }

      // データ構成が想定外だった場合に漏れないようにする
      for (i = 0; i < itemList.length; i++) {
        if (itemList[i]) {
          sortedItemsList.push(itemList[i]);
        }
      }

      var callbackInfos = [];
      for (i = 0; i < sortedItemsList.length; i++) {
        item = sortedItemsList[i];
        thumbnail = item.mainImgList && item.mainImgList[0] && item.mainImgList[0].imgInfo && item.mainImgList[0].imgInfo.path;

        var price_string = '<span class="item-price-out-tax">￥' + getComma(item.spwl) + '</span><span class="item-price-in-tax">(税込￥' + getComma(item.spl) + ')</span>';
        price_string = (item.spwl != item.spwh) ? price_string + '～' : price_string;
        callbackInfos.push({
          itemCode: item.itCd,
          thumbnail: (thumbnail || '').replace('_l_', '_s_'),
          price: item.price || price_string || catalogSkuInfos[0] && catalogSkuInfos[0].price || ''
        });
      }
      callback(callbackInfos);

      } else {
        console.log('データなし');
      }
    } else {
      var callbackInfos = [];
      callbackInfos.push({
        itemCode: 'none',
        thumbnail: '',
        price: ''
      });
      callback(callbackInfos);
    }
  }).fail(function (jqXHR, textStatus, errorThrown) {
    callback([]);
  });
}

/** カタログ商品情報を取得し、商品リストのHTMLを構築する */
function getCatalogInfoAndCreateHtml(currentCatalog, item, htmls, htmlsIndex) {
  var catalogSkuInfos = [];
  if (item.sku) {
    for (var i = 0; i < item.sku.length; i++) {
      // pは以下のような文字列（サイズコード,サイズ名,カラーコード,カラー名,価格）
      // "Y,シングルセット,A,ローズボーダー,7990"
      var p = item.sku[i].p.split(',');
  
      if (p.length === 5) {
        catalogSkuInfos.push({
          sizeCode: p[0],
          colorCode: p[2],
          price: p[4]
        });
      }
    }
  }

  getCatalogItemInfo(currentCatalog, item.no, catalogSkuInfos, function(callbackInfos) {
    // Ajax（非同期）で商品情報を取得するため、順序が変わらないように、与えられたインデックス(htmlsIndex)に設定する

    if (callbackInfos.length > 0) {
      var skuHtmls = [];
      for (var i = 0; i < callbackInfos.length; i++) {
        var info = callbackInfos[i];
        skuHtmls.push(createItemListItemHtml(info.itemCode, info.thumbnail, item.no, item.nm, info.price));
      }      

      htmls[htmlsIndex] = skuHtmls.join('')
    } else {
      // 情報が取得できなかった場合も、呼び出し元に処理完了を通知できるように、undefined以外の値を設定する
      htmls[htmlsIndex] = '';
    }
  });
}

/**
 * 商品リスト項目のHTMLを生成する。
 * 
 * @param {string} itemCode 商品コード
 * @param {string} thumbnail サムネイルURL
 * @param {string} catalogItemNumber カタログ商品番号
 * @param {string} itemName 商品名
 * @param {string} price 価格
 */
function createItemListItemHtml(itemCode, thumbnail, catalogItemNumber, itemName, price) {
  if (itemCode == "none") {
  return '<div class="product_list not_found">'
  +			'<div class="pd_upper">'
  +				'<div class="pd_upper_left">'
  +					'<p class="pd_thumbnail">'
  +						'<img src="https://www.nissen.co.jp/res/p/img/favorite/no-item.jpg" alt="商品サムネイル" onerror="defaultImg( this )">'
  +					'</p>'
  +				'</div>'
  +				'<div class="pd_upper_right">'
  +					'<p class="pd_number_s">' + catalogItemNumber.slice(-2) + '</p>'
  +					'<p class="pd_name">' + $('<p/>').text(itemName).html() + '</p>'
  +					'<p class="pd_error">販売終了もしくは販売見合わせ中のため、<br>現在商品情報を表示できません</p>'
  +				'</div>'
  +			'</div>'
  +	'</div>';
  } else {
  return '<div class="product_list">'
  +		'<a href="' + '/item/' + itemCode + '" target="_blank">'
  +			'<div class="pd_upper">'
  +				'<div class="pd_upper_left">'
  +					'<p class="pd_thumbnail">'
  +						'<img src="' + thumbnail + '" alt="商品サムネイル" onerror="defaultImg( this )">'
  +					'</p>'
  +				'</div>'
  +				'<div class="pd_upper_right">'
  +					'<p class="pd_number_s">' + catalogItemNumber.slice(-2) + '</p>'
  +					'<p class="pd_name">' + $('<p/>').text(itemName).html() + '</p>'
  +					'<p class="pd_yen">'
  +						'本体価格<span class="pd_price">' + price + '</span>'
  +					'</p>'
  +					'<p class="pd_number_wrapper">'
  +						'商品番号：<span class="pd_number">' + catalogItemNumber + '</span>'
  +					'</p>'
  +				'</div>'
  +			'</div>'
  +		'</a>'
  +	'</div>';
  }
}